import { Box, Typography } from '@mui/material';
import { convertToHtml } from '@/utils';

interface Props {
    description: string | string[];
}

export default function FormFieldDescription({ description }: Props) {
    return (
        <Box sx={{ padding: '0px 16px 0px 0px', marginTop: '12px' }}>
            <Typography
                dangerouslySetInnerHTML={{
                    // Older questions can store their description as lines
                    __html: convertToHtml(
                        Array.isArray(description) ? description.join('\n') : description,
                    ),
                }}
                // A step down from the question: 14px under its 16px, 13px under its 14px on phones
                sx={{ display: 'block', fontSize: { xs: 13, sm: 14 }, color: 'neutral.N_700' }}
                variant="body2"
            />
        </Box>
    );
}
